import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ActivePlanGuard implements CanActivate {

  constructor(private router: Router) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    
    // Check if region and role are available
    const region = localStorage.getItem('selectedRegion');
    const role = localStorage.getItem('selectedRole');
    
    if (!region || !role) {
      console.warn('Region and Role must be selected before accessing reports. Redirecting to /model');
      this.router.navigate(['/model']);
      return false;
    }
    
    // Check if active plan is available
    const currentPlanID = localStorage.getItem('currentPlanID');
    
    if (!currentPlanID || currentPlanID === '0') {
      console.warn('Active Plan must be selected before accessing reports. Redirecting to /plan-manager');
      this.router.navigate(['/plan-manager']);
      return false;
    }
    
    return true;
  }
}
